// test2154
(2154 && 0);
